module.exports = __webpack_public_path__ + "img/icon6.dc3facc1.svg";